import MasterService from "@/services/MasterService";
import Vue from "vue";
import moment from "moment";
import { BASEURL } from "@/config/index";

const getGlobalOptionValue = (globalOptions, key) => {
  if (Array.isArray(globalOptions)) {
    let obj = globalOptions.find((x) => x.go_key === key);
    if (obj) {
      return obj["go_value"];
    } else {
      return state[key];
    }
  }
  return state[key];
};

const setTimScriptHeader = () => {
  let recaptchaScript = document.createElement("script");
  recaptchaScript.setAttribute("src", `${BASEURL}/Tim/timapi.js`);
  document.head.appendChild(recaptchaScript);
};

const state = {
  global_options_records: [],
  organization_records: [],
  LangID: 1,
  getMobileCode: "91",
  currentDate: moment().format("YYYY-MM-DD"),
  currentTime: moment().format("HH:mm"),
  allow_pastBooking: "N",
  currencyData: {
    curr_id: "",
    curr_code: "",
  },
  MANAGER_AUTH_REQ_FOR_CHANGES: "Y",
  MANAGER_AUTH_REQ_FOR_REPRINT: "Y",
  ALLOW_CINEMA_SPECIFIC_SWAP_ONLY: "Y",
  USE_NEOLEAP_POS_PAYMENT: "Y",
  CLIENT_SETUP_NAME: "",
  OPEN_APPLICABLE_OFFER_POPUP: "Y",
  POS_CUSTOMER_POPUP: "Y",
  POS_DIRECT_PRINT: "Y",
  SHOW_VEG_NONVEG_lOGO: "Y",
  AUTO_ADMIT_TICKET_AFTER_SHOW: "Y",
  SHOW_PRINT_RECEIPT_BTN_POS: "N",
  DELIVER_ITEM_FROM_POS_PICKUP: "Y",
  DIRECT_DELIVER_READY_TO_SERVE_ITEMS: "N",
  PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY: "N",
  NEOLEAP_WEBSOCKET_URL: "wss://localhost:7000/neoleap_integration",
  USE_NEOLEAP_POS_PAYMENT: "Y",
  USE_TIM_INTEGRATION: "N",
  USE_OMA_CINEPOLIS_CARD_MACHINE: "N",
  USE_CREDIT_CARD_MACHINE_PAYMENT: "N",
  POS_INPUT_CASH_VALIDATION: "Y",
  ALLOW_CINEMA_SPECIFIC_REFUND_ONLY: "Y",
  STOCK_DEDUCTION: "Y",
  STOCK_DEDUCTION_CONCESSION: "Y",
  ALLOW_PARTIAL_REFUND: "N",
  OPERATION_COUNTRY: "191",
  DEFAULT_MOBILE_CODE: "966",
  ENABLE_SEAT_LAYOUT_REAL_TIME: "Y",
  POS_AUDIT_LOGS_ACTIVE: "N",
  ticket_print_type: 1,
  DEFAULT_POS_PAYMENT_MODE: 1,
  MIN_FRACTION_DIGITS: 3,
  fnbRemarks: "",
  boRemarks: "",
  SHOW_MERCHANDISE_MODULE: "N",
  SHOW_CHANNEL_WISE_SEAT_BLOCKING: "N",
  POS_STORE_SELECTION: "N",
  POS_LOCK_SCREEN_TIME: "120",
  _24_HRS_FORMAT: "HH:mm",
  OPEN_PACAKAGE_OFFER_POPUP: "N",
};

const mutations = {
  SET_GLOBAL_OPTIONS: (state, payload) => {
    state.global_options_records = payload;
  },
  SET_ORGANIZATION_DETAILS: (state, payload) => {
    state.organization_records = payload;
  },
  SET_CURRENCY_DATA: (state, payload) => {
    state.currencyData = payload;
  },
  SET_OFFER_POPUP_OPEN_AUTOMATICALLY: (state, payload) => {
    state.OPEN_APPLICABLE_OFFER_POPUP = payload;
  },
  SET_PACKAGE_OFFER_POPUP_OPEN_AUTOMATICALLY: (state, payload) => {
    state.OPEN_PACAKAGE_OFFER_POPUP = payload;
  },
  SET_CUSTOMER_POPUP_OPEN_AUTOMATICALLY: (state, payload) => {
    state.POS_CUSTOMER_POPUP = payload;
  },
  SET_SHOW_VEG_NONVEG_lOGO: (state, payload) => {
    state.SHOW_VEG_NONVEG_lOGO = payload;
  },
  SET_DIRECT_DELIVER_READY_TO_SERVE_ITEMS: (state, payload) => {
    state.DIRECT_DELIVER_READY_TO_SERVE_ITEMS = payload;
  },
  SET_PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY: (state, payload) => {
    state.PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY = payload;
  },
  SET_NEOLEAP_INTEGRATION: (state, payload) => {
    state.USE_NEOLEAP_POS_PAYMENT = payload;
    if (payload == "Y") {
      state.USE_TIM_INTEGRATION = "N";
      state.USE_OMA_CINEPOLIS_CARD_MACHINE = "N";
    }
  },
  SET_USE_CREDIT_CARD_MACHINE_PAYMENT: (state, payload) => {
    state.USE_CREDIT_CARD_MACHINE_PAYMENT = payload;
    if (payload == "Y") {
      state.USE_TIM_INTEGRATION = "N";
      state.USE_OMA_CINEPOLIS_CARD_MACHINE = "N";
      state.USE_NEOLEAP_POS_PAYMENT = "N";
    }
  },
  SET_OMA_INTEGRATION: (state, payload) => {
    state.USE_OMA_CINEPOLIS_CARD_MACHINE = payload;
    if (payload == "Y") {
      state.USE_TIM_INTEGRATION = "N";
      state.USE_NEOLEAP_POS_PAYMENT = "N";
    }
  },
  SET_NEOLEAP_WEBSOCKET_URL: (state, payload) => {
    state.NEOLEAP_WEBSOCKET_URL = payload;
  },
  SET_AUTH_REQURIED_FOR_CHANGES: (state, payload) => {
    state.MANAGER_AUTH_REQ_FOR_CHANGES = payload;
  },
  SET_AUTH_REQURIED_FOR_REPRINT: (state, payload) => {
    state.MANAGER_AUTH_REQ_FOR_REPRINT = payload;
  },
  SET_AUTO_ADMIT_TICKET: (state, payload) => {
    state.AUTO_ADMIT_TICKET_AFTER_SHOW = payload;
  },
  SET_DIRECT_PRINT: (state, payload) => {
    state.POS_DIRECT_PRINT = payload;
  },
  SET_PRINT_RECEIPT_BTN_POS: (state, payload) => {
    state.SHOW_PRINT_RECEIPT_BTN_POS = payload;
  },
  SET_POS_AMOUNT_VALIDATION: (state, payload) => {
    state.POS_INPUT_CASH_VALIDATION = payload;
  },
  SET_ALLOW_CINEMA_SPECIFIC_REFUND_ONLY: (state, payload) => {
    state.ALLOW_CINEMA_SPECIFIC_REFUND_ONLY = payload;
  },
  SET_STOCK_DEDUCTION: (state, payload) => {
    state.STOCK_DEDUCTION = payload;
  },
  SET_CLIENT_SETUP_NAME: (state, payload) => {
    state.CLIENT_SETUP_NAME = payload;
  },
  SET_ALLOW_PARTIAL_REFUND: (state, payload) => {
    state.ALLOW_PARTIAL_REFUND = payload;
  },
  SET_OPERATION_COUNTRY: (state, payload) => {
    state.OPERATION_COUNTRY = payload;
  },
  SET_DEFAULT_MOBILE_CODE: (state, payload) => {
    state.DEFAULT_MOBILE_CODE = payload;
  },
  SET_ENABLE_SEAT_LAYOUT_REAL_TIME: (state, payload) => {
    state.ENABLE_SEAT_LAYOUT_REAL_TIME = payload;
  },
  SET_POS_AUDIT_LOGS_ACTIVE: (state, payload) => {
    state.POS_AUDIT_LOGS_ACTIVE = payload;
  },
  SET_TIM_INTEGRATION: (state, payload) => {
    state.USE_TIM_INTEGRATION = payload;
    if (payload == "Y") {
      state.USE_NEOLEAP_POS_PAYMENT = "N";
      state.USE_OMA_CINEPOLIS_CARD_MACHINE = "N";
      setTimScriptHeader();
    }
  },
  SET_TICKET_PRINT_STATE: (state, payload) => {
    state.ticket_print_type = payload;
  },
  SET_DEFAULT_PAYMENT_MODE: (state, payload) => {
    state.DEFAULT_POS_PAYMENT_MODE = payload;
  },
  SET_MIN_FRACTION_DIGITS: (state, payload) => {
    state.MIN_FRACTION_DIGITS = payload;
  },
  SET_24_HRS_FORMAT: (state, payload) => {
    let format = "HH:mm";
    if (payload.toLowerCase() == "n") {
      format = "hh:mm A";
    } else if (payload.toLowerCase() == "y") {
      format = "HH:mm";
    } else {
      format = "HH:mm";
    }
    state._24_HRS_FORMAT = format;
  },
  SET_FNB_REMARKS: (state, payload) => {
    state.fnbRemarks = payload;
  },
  SET_BO_REMARKS: (state, payload) => {
    state.boRemarks = payload;
  },
  SET_SHOW_MERCHANDISE_MODULE: (state, payload) => {
    state.SHOW_MERCHANDISE_MODULE = payload;
  },
  SET_SHOW_CHANNEL_WISE_SEAT_BLOCKING: (state, payload) => {
    state.SHOW_CHANNEL_WISE_SEAT_BLOCKING = payload;
  },
  SET_POS_STORE_SELECTION: (state, payload) => {
    state.POS_STORE_SELECTION = payload;
  },
  SET_POS_LOCK_SCREEN_TIME: (state, payload) => {
    state.POS_LOCK_SCREEN_TIME = payload;
  },
};

const actions = {
  fetchGlobalOptions: ({ commit }, payload) => {
    MasterService.GetGlobalOptions().then((response) => {
      const { data } = response;
      if (data && data.status && data.Records.length > 0) {
        commit("SET_GLOBAL_OPTIONS", data.Records);
        let currCodeObj = data.Records.find((global_option_obj) => {
          return global_option_obj.go_key == "CURRENCY";
        });

        commit(
          "SET_OFFER_POPUP_OPEN_AUTOMATICALLY",
          getGlobalOptionValue(data.Records, "OPEN_APPLICABLE_OFFER_POPUP")
        );
        commit(
          "SET_PACKAGE_OFFER_POPUP_OPEN_AUTOMATICALLY",
          getGlobalOptionValue(data.Records, "OPEN_PACAKAGE_OFFER_POPUP")
        );
        commit(
          "SET_CUSTOMER_POPUP_OPEN_AUTOMATICALLY",
          getGlobalOptionValue(data.Records, "POS_CUSTOMER_POPUP")
        );
        commit(
          "SET_SHOW_VEG_NONVEG_lOGO",
          getGlobalOptionValue(data.Records, "SHOW_VEG_NONVEG_lOGO")
        );
        commit(
          "SET_DIRECT_DELIVER_READY_TO_SERVE_ITEMS",
          getGlobalOptionValue(
            data.Records,
            "DIRECT_DELIVER_READY_TO_SERVE_ITEMS"
          )
        );
        commit(
          "SET_PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY",
          getGlobalOptionValue(
            data.Records,
            "PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY"
          )
        );
        commit(
          "SET_OMA_INTEGRATION",
          getGlobalOptionValue(data.Records, "USE_OMA_CINEPOLIS_CARD_MACHINE")
        );
        commit(
          "SET_NEOLEAP_INTEGRATION",
          getGlobalOptionValue(data.Records, "USE_NEOLEAP_POS_PAYMENT")
        );
        commit(
          "SET_USE_CREDIT_CARD_MACHINE_PAYMENT",
          getGlobalOptionValue(data.Records, "USE_CREDIT_CARD_MACHINE_PAYMENT")
        );
        commit(
          "SET_TIM_INTEGRATION",
          getGlobalOptionValue(data.Records, "USE_TIM_INTEGRATION")
        );
        commit(
          "SET_NEOLEAP_WEBSOCKET_URL",
          getGlobalOptionValue(data.Records, "NEOLEAP_WEBSOCKET_URL")
        );
        commit(
          "SET_AUTH_REQURIED_FOR_CHANGES",
          getGlobalOptionValue(
            data.Records,
            "MANAGER_AUTH_REQURIED_FOR_CHANGES"
          )
        );
        commit(
          "SET_AUTH_REQURIED_FOR_REPRINT",
          getGlobalOptionValue(data.Records, "MANAGER_AUTH_REQ_FOR_REPRINT")
        );
        commit(
          "SET_AUTO_ADMIT_TICKET",
          getGlobalOptionValue(data.Records, "AUTO_ADMIT_TICKET_AFTER_SHOW")
        );
        commit(
          "SET_DIRECT_PRINT",
          getGlobalOptionValue(data.Records, "POS_DIRECT_PRINT")
        );
        commit(
          "SET_PRINT_RECEIPT_BTN_POS",
          getGlobalOptionValue(data.Records, "SHOW_PRINT_RECEIPT_BTN_POS")
        );
        commit(
          "SET_POS_AMOUNT_VALIDATION",
          getGlobalOptionValue(data.Records, "POS_INPUT_CASH_VALIDATION")
        );
        commit(
          "SET_ALLOW_CINEMA_SPECIFIC_REFUND_ONLY",
          getGlobalOptionValue(
            data.Records,
            "ALLOW_CINEMA_SPECIFIC_REFUND_ONLY"
          )
        );
        commit(
          "SET_STOCK_DEDUCTION",
          getGlobalOptionValue(data.Records, "STOCK_DEDUCTION")
        );
        commit(
          "SET_CLIENT_SETUP_NAME",
          getGlobalOptionValue(data.Records, "CLIENT_SETUP_NAME")
        );
        commit(
          "SET_ALLOW_PARTIAL_REFUND",
          getGlobalOptionValue(data.Records, "ALLOW_PARTIAL_REFUND")
        );
        commit(
          "SET_OPERATION_COUNTRY",
          getGlobalOptionValue(data.Records, "OPERATION_COUNTRY")
        );
        commit(
          "SET_DEFAULT_MOBILE_CODE",
          getGlobalOptionValue(data.Records, "DEFAULT_MOBILE_CODE")
        );
        commit(
          "SET_MIN_FRACTION_DIGITS",
          getGlobalOptionValue(data.Records, "MIN_FRACTION_DIGITS")
        );
        commit(
          "SET_ENABLE_SEAT_LAYOUT_REAL_TIME",
          getGlobalOptionValue(data.Records, "ENABLE_SEAT_LAYOUT_REAL_TIME")
        );
        commit(
          "SET_POS_AUDIT_LOGS_ACTIVE",
          getGlobalOptionValue(data.Records, "POS_AUDIT_LOGS_ACTIVE")
        );
        commit(
          "SET_DEFAULT_PAYMENT_MODE",
          getGlobalOptionValue(data.Records, "DEFAULT_POS_PAYMENT_MODE")
        );
        commit(
          "SET_24_HRS_FORMAT",
          getGlobalOptionValue(data.Records, "24_HRS_FORMAT")
        );
        commit(
          "SET_SHOW_MERCHANDISE_MODULE",
          getGlobalOptionValue(data.Records, "SHOW_MERCHANDISE_MODULE")
        );
        commit(
          "SET_SHOW_CHANNEL_WISE_SEAT_BLOCKING",
          getGlobalOptionValue(data.Records, "SHOW_CHANNEL_WISE_SEAT_BLOCKING")
        );
        commit(
          "SET_POS_STORE_SELECTION",
          getGlobalOptionValue(data.Records, "POS_STORE_SELECTION")
        );
        commit(
          "SET_POS_LOCK_SCREEN_TIME",
          getGlobalOptionValue(data.Records, "POS_LOCK_SCREEN_TIME")
        );

        let payload = {
          tableName: "ms_currencies",
          curr_is_active: "Y",
          curr_id: currCodeObj.go_value,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              let currObj = {
                curr_id: data.Records[0].curr_id,
                curr_code: data.Records[0].curr_code,
              };
              commit("SET_CURRENCY_DATA", currObj);
            } else {
              // Show Error Message:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getActiveScreenByCinemaId :", error);
          });
      } else {
        console.log("Error in fetching global options");
      }
    });
  },
  fetchHealthMeta: ({ commit }) => {
    let payload = {
      git: {},
      os: {},
      process: {},
    };

    MasterService.GetHealthMeta()
      .then((response) => {
        const { data } = response;
        payload = data;
      })
      .catch(console.log)
      .finally(() => {
        commit("SET_HEALTH_META", payload);
      });
  },
  fetchOrgDetails: ({ commit }, payload) => {
    MasterService.GetOrgDetails().then((response) => {
      const { data } = response;
      if (data && data.status && data.Records.length > 0) {
        commit("SET_ORGANIZATION_DETAILS", data.Records[0]);
      } else {
        console.log("Error", data.message);
      }
    });
  },
  HARD_RELOAD_POS: ({ commit }, payload) => {
    window.location.reload();
  },
  updateTicketPrintType: ({ commit }, payload) => {
    commit("SET_TICKET_PRINT_STATE", payload);
  },
  updateFnbRemarks: ({ commit }, payload) => {
    commit("SET_FNB_REMARKS", payload);
  },
  updateBoRemarks: ({ commit }, payload) => {
    commit("SET_BO_REMARKS", payload);
  },
};

const getters = {
  getGlobalOptions: (state) => state.global_options_records,
  getOrganizationDetails: (state) => state.organization_records,
  AREA_LANG_ID: (state) => state.LangID,
  getMobileCode: (state) => state.getMobileCode,
  getPastBooking: (state) => state.allow_pastBooking,
  getCurrencyData: (state) => state.currencyData,
  MANAGER_AUTH_FOR_CHANGES: (state) => state.MANAGER_AUTH_REQ_FOR_CHANGES,
  MANAGER_AUTH_FOR_REPRINT: (state) => state.MANAGER_AUTH_REQ_FOR_REPRINT,
  ALLOW_CINEMA_SPECIFIC_SWAP_ONLY: (state) =>
    state.ALLOW_CINEMA_SPECIFIC_SWAP_ONLY,
  ALLOW_CINEMA_SPECIFIC_REFUND_ONLY: (state) =>
    state.ALLOW_CINEMA_SPECIFIC_REFUND_ONLY,
  USE_NEOLEAP_POS_PAYMENT: (state) => state.USE_NEOLEAP_POS_PAYMENT,
  USE_OMA_CINEPOLIS_CARD_MACHINE: (state) =>
    state.USE_OMA_CINEPOLIS_CARD_MACHINE,
  USE_TIM_INTEGRATION: (state) => state.USE_TIM_INTEGRATION,
  USE_CREDIT_CARD_MACHINE_PAYMENT: (state) =>
    state.USE_CREDIT_CARD_MACHINE_PAYMENT,
  OPEN_APPLICABLE_OFFER_POPUP: (state) => state.OPEN_APPLICABLE_OFFER_POPUP,
  OPEN_PACAKAGE_OFFER_POPUP: (state) => state.OPEN_PACAKAGE_OFFER_POPUP,
  POS_CUSTOMER_POPUP: (state) => state.POS_CUSTOMER_POPUP,
  SHOW_VEG_NONVEG_lOGO: (state) => state.SHOW_VEG_NONVEG_lOGO,
  DIRECT_DELIVER_READY_TO_SERVE_ITEMS: (state) =>
    state.DIRECT_DELIVER_READY_TO_SERVE_ITEMS,
  PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY: (state) =>
    state.PREVENT_ONLINE_READY_TO_SERVE_DIRECT_DELIVERY,
  NEOLEAP_WEBSOCKET_URL: (state) => state.NEOLEAP_WEBSOCKET_URL,
  AUTO_ADMIT_TICKET_AFTER_SHOW: (state) => state.AUTO_ADMIT_TICKET_AFTER_SHOW,
  POS_DIRECT_PRINT: (state) => state.POS_DIRECT_PRINT,
  SHOW_PRINT_RECEIPT_BTN_POS: (state) => state.SHOW_PRINT_RECEIPT_BTN_POS,
  POS_INPUT_CASH_VALIDATION: (state) => state.POS_INPUT_CASH_VALIDATION,
  BRGLOPSTDE: (state) => state.STOCK_DEDUCTION,
  CLIENT_SETUP_NAME: (state) => state.CLIENT_SETUP_NAME,
  ALLOW_PARTIAL_REFUND: (state) => state.ALLOW_PARTIAL_REFUND,
  OPERATION_COUNTRY: (state) => state.OPERATION_COUNTRY,
  DEFAULT_MOBILE_CODE: (state) => state.DEFAULT_MOBILE_CODE,
  ENABLE_SEAT_LAYOUT_REAL_TIME: (state) => state.ENABLE_SEAT_LAYOUT_REAL_TIME,
  POS_AUDIT_LOGS_ACTIVE: (state) => state.POS_AUDIT_LOGS_ACTIVE,
  GET_TICKET_PRINT_TYPE: (state) => state.ticket_print_type,
  DEFAULT_POS_PAYMENT_MODE: (state) => state.DEFAULT_POS_PAYMENT_MODE,
  GET_FNB_REMARKS: (state) => state.fnbRemarks,
  GET_BO_REMARKS: (state) => state.boRemarks,
  TIME_FORMAT: (state) => state._24_HRS_FORMAT,
  MIN_FRACTION_DIGITS: (state) => state.MIN_FRACTION_DIGITS,
  SHOW_MERCHANDISE_MODULE: (state) => state.SHOW_MERCHANDISE_MODULE,
  SHOW_CHANNEL_WISE_SEAT_BLOCKING: (state) => state.SHOW_CHANNEL_WISE_SEAT_BLOCKING,
  POS_STORE_SELECTION: (state) => state.POS_STORE_SELECTION,
  POS_LOCK_SCREEN_TIME: (state) => state.POS_LOCK_SCREEN_TIME,
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/MasterStore.js